<img
  #imgElement
  (load)="imgLoadedEvent(imgElement)"
  (error)="imgNotFoundEvent(imgElement)"
  [src]="src"
  [alt]="alt"
/>
